import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { color, diagramStyle } from './palette';

/**
 * Request → route → service → LanternClient → rewriter → Postgres: every read goes through the rewriter, which injects the
 * RLS predicate; a staff bypass leaves an audit_log row on the way.
 */
export const RequestPath: FC = () => {
  const theme = useTheme();
  const sub = { fill: color.muted, fontSize: 13 } as const;
  const lbl = { fontSize: 15, fontWeight: 600 } as const;
  const hops = ['browser', 'FastAPI route', 'service', 'LanternClient', 'rewriter', 'Postgres'];

  return (
    <svg viewBox="0 0 940 260" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Request → route → service → LanternClient → rewriter → Postgres" style={diagramStyle(theme)}>
      <defs>
        <marker id="academy-arrow-request" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto">
          <path d="M0,0 L8,4 L0,8 z" fill={color.muted} />
        </marker>
      </defs>
      {hops.map((name, i) => {
        const x = 20 + i * 156;
        const rewriter = name === 'rewriter';
        return (
          <g key={name}>
            <rect x={x} y="95" width="120" height="60" rx="10" fill={rewriter ? color.accent : 'none'} fillOpacity={rewriter ? 0.18 : 1} stroke={rewriter ? color.accent : color.muted} strokeWidth={rewriter ? 3 : 2} />
            <text x={x + 60} y="130" textAnchor="middle" style={lbl} fill={color.fg}>
              {name}
            </text>
            {i < hops.length - 1 && <line x1={x + 122} y1="125" x2={x + 154} y2="125" stroke={color.muted} strokeWidth="2" markerEnd="url(#academy-arrow-request)" />}
          </g>
        );
      })}
      <text x="158" y="85" textAnchor="middle" style={sub}>
        request
      </text>
      <text x="704" y="80" textAnchor="middle" fontSize="14" fontWeight="600" fill={color.accent}>
        RLS predicate injected
      </text>
      {/* The staff bypass: the one way round the predicate, and it is written down */}
      <line x1="704" y1="157" x2="704" y2="205" stroke={color.warn} strokeWidth="2" strokeDasharray="4 4" markerEnd="url(#academy-arrow-request)" />
      <text x="714" y="186" fontSize="13" fill={color.warn}>
        staff bypass
      </text>
      <rect x="644" y="207" width="120" height="32" rx="6" fill="none" stroke={color.muted} strokeWidth="2" />
      <text x="704" y="228" textAnchor="middle" fontSize="14" fontFamily="monospace" fill={color.fg}>
        audit_log
      </text>
    </svg>
  );
};
